import uiConfig from 'src/lib/ui/config';
import { SelectionalScript } from 'src/replicant/conversation/conservation.ruleset';
import StateObserver from 'src/StateObserver';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import sounds from 'src/lib/sounds';
import PopupSpeechBubbleBase, {
  SpeechBubbleCloseHandler,
} from './PopupSpeechBubbleBase';
import { animate, View } from '@play-co/timestep-core/ui';
import { GCInstant as platform } from 'src/lib/gcinstant';
import {
  getPlayerIdFromConversation,
  getScriptText,
} from 'src/game/conversation/conversation.utils';
import { getScreenTop } from '../../../lib/utils';

export default class PopupSelectionalScript extends PopupSpeechBubbleBase {
  private options: ButtonScaleViewWithText[] = [];

  constructor(opts: {
    superview: View;
    close: SpeechBubbleCloseHandler<1 | 2 | 3>;
  }) {
    super({ ...opts, $subFeature: 'selectional' });
  }

  public init(script: SelectionalScript) {
    const { user, ui } = StateObserver.getState();

    super.init({
      id: script.id,
      move_to: script.move_to,
      message: getScriptText(
        user,
        script.id,
        ui.locale,
        getPlayerIdFromConversation(script.id) !== platform.playerID,
      ),
    });

    const baseOptionY = 650 - getScreenTop();
    this.options = this.getOptions(script).map((option, i, { length }) => {
      const button = new ButtonScaleViewWithText({
        ...uiConfig.buttons.primary,
        width: 400,
        height: 90,
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: baseOptionY - 102 * (length - i - 1),
        font: 'Body',
        fontSize: 32,
        localeText: () => option,
        onClick: async () => {
          sounds.sfx.play('ok');
          this.opts.close(i + 1);
        },
        tracking: { feature: 'conversation-answer', $subFeature: `${i}` },
        visible: false,
        opacity: 0,
        scaleX: 0.9,
        scaleY: 0.9,
      });
      button.setDisabled(true);
      this.box.addSubview(button);

      return button;
    });
  }

  private getOptions(script: SelectionalScript) {
    const options: string[] = [];
    const localeSuffix =
      StateObserver.getState().ui.locale === 'en' ? 'en' : 'jp';
    for (let i = 1; i <= 5; ++i) {
      const prop = `option_${i}_${localeSuffix}` as keyof typeof script;
      const option = script[prop];
      if (!option) continue;
      options.push(option);
    }
    return options;
  }

  public async fadeIn() {
    await super.fadeIn();

    this.currentAnimation?.then(() => {
      this.options.forEach((option, i) => {
        option.updateOpts({ visible: true });
        animate(option)
          .wait(i * 50)
          .then({ opacity: 1, scaleX: 1, scaleY: 1 }, 100)
          .then(() => option.setDisabled(false));
      });
    });
  }
}
